import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PageTitle from "/src/components/UI/TitleWithBreadcrumb.vue";
import Modal from "/src/components/UI/Modal.vue";
import YearDropdown from "/src/components/UI/YearDropdown.vue";
import DetailsSkeleton from "/src/views/Details/DetailsSkeleton.vue";
import ItemsSkeleton from "/src/views/ItemsSkeleton.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import ImagePopup from "/src/components/UI/ImagePopup.vue";
const app = createApp(App);
app.component("PageTitle", PageTitle);
app.component("YearDropdown", YearDropdown);
app.component("DetailsSkeleton", DetailsSkeleton);
app.component("ItemsSkeleton", ItemsSkeleton);
app.component("ImagePopup", ImagePopup);
app.component("Modal", Modal);
app.use(VueEasyLightbox);
app.use(store);
app.use(router);
app.mount("#app");
